import IconoWhatsapp from './IconoWhatsapp'

const MENSAJE =
  'Hola, vi Bengali Leopard Cats y quiero más información sobre los gaticos disponibles: precios, razas y disponibilidad. ¿Me pueden ayudar?'

/**
 * Botón fijo visible en todo el sitio, para consultas generales (no atadas a
 * un producto puntual — para eso está "Preguntar por WhatsApp" en cada
 * ficha, que arma el mensaje del lado del servidor). Sin número configurado,
 * no se renderiza nada, en vez de un botón roto.
 *
 * Es la única superficie del sitio que usa el verde de marca de WhatsApp en
 * vez de la paleta dorada: es un patrón de UI tan reconocible (botón
 * flotante verde con el logo) que romperlo por consistencia visual haría el
 * botón menos identificable, no más elegante.
 */
function BotonWhatsappFlotante() {
  const numero = import.meta.env.VITE_WHATSAPP_NUMERO
  if (!numero) return null

  const url = `https://wa.me/${numero}?text=${encodeURIComponent(MENSAJE)}`

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribir por WhatsApp"
      className="fixed right-4 bottom-[calc(1rem+env(safe-area-inset-bottom))] z-40 flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-noche/50 transition-transform duration-200 hover:scale-105 active:scale-95 sm:right-6 sm:bottom-[calc(1.5rem+env(safe-area-inset-bottom))]"
    >
      <IconoWhatsapp className="size-7" />
    </a>
  )
}

export default BotonWhatsappFlotante
